import { Outlet } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main id="main-content" className="grow-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
